import { render, staticRenderFns } from "./pageCustomDialog.vue?vue&type=template&id=c55ae284&scoped=true&"
import script from "./pageCustomDialog.vue?vue&type=script&lang=ts&"
export * from "./pageCustomDialog.vue?vue&type=script&lang=ts&"
import style0 from "./pageCustomDialog.vue?vue&type=style&index=0&id=c55ae284&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c55ae284",
  null
  
)

export default component.exports